import { PureSettings } from '@/components/base-layouts/defaultSettings';

export interface AppState extends PureSettings {
  lang: string;
  device: 'mobile' | 'desktop' | string;
  transitionName: string;
  multiTab: boolean;
  multiTabFixed: boolean;
}

export const state: AppState = {
  lang: 'zh-CN',
  device: 'desktop',
  layout: 'side',
  navTheme: 'dark',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixedSidebar: true,
  menu: { locale: false },
  splitMenus: false,
  title: '表单记录',
  primaryColor: '#1890ff',
  colorWeak: false,
  transitionName: '',
  multiTab: true,
  multiTabFixed: false,
};
